export const PAGE_KEY = 'b2b-landing-free-trial';
